import React from 'react';
import PropTypes from 'prop-types';

const Heading = ({ text }) => {
  return (
    <h2 className="h2 pb-2 border-bottom border-saxon-gold">
      {text}
    </h2>
  );
};

Heading.propTypes = {
  text: PropTypes.string.isRequired
};

const ContentWrapper = ({ bgDark, children }) => {
  const contentClass = `l-section__content-wrapper ${bgDark ? 'py-25 py-md-35' : 'pt-0 pb-10 pb-md-20'} px-md-20`;
  return (
    <div className={contentClass}>
      {children}
    </div>
  );
};

ContentWrapper.propTypes = {
  bgDark: PropTypes.bool,
  children: PropTypes.array.isRequired
};

const FormSection = ({ bgDark, containerClass, fieldset, heading, children }) => {
  return (
    <div className={`${bgDark ? 'c-chevron-bg mt-5' : 'mt-12'} ${containerClass ?? ''}`}>
      {
        fieldset ?
          <fieldset>
            <ContentWrapper bgDark={bgDark}>
              <legend className="m-0 float-none">
                <Heading text={heading}/>
              </legend>
              {children}
            </ContentWrapper>
          </fieldset>
          :
          <ContentWrapper bgDark={bgDark}>
            <Heading text={heading}/>
            {children}
          </ContentWrapper>
      }
    </div>
  );
};

FormSection.propTypes = {
  bgDark: PropTypes.bool,
  fieldset: PropTypes.bool,
  containerClass: PropTypes.string,
  heading: PropTypes.string.isRequired,
  children: PropTypes.object.isRequired
};

export default FormSection;